import { Link } from "react-router-dom";
import Tag from "@/components/base/Tag";
import type { WorkItem } from "@/mocks/works";

interface WorkCardProps {
  item: WorkItem;
}

export default function WorkCard({ item }: WorkCardProps) {
  return (
    <Link
      to={`/works/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative w-full overflow-hidden pt-[133%]">
        <img
          src={item.cover}
          alt={`${item.title}（${item.year}）剧照封面 - 佐佐木明希${item.roleType}作品`}
          title={`${item.title} 佐佐木明希 影视作品`}
          className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3">
          <Tag tone={item.category === "电影" ? "accent" : "primary"}>{item.category}</Tag>
        </span>
        <span className="absolute right-3 top-3 rounded-full bg-foreground-950/70 px-2.5 py-0.5 text-xs font-label text-background-50">
          {item.year}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
          {item.title}
        </h3>
        <p className="mt-1.5 text-xs text-foreground-500">
          {item.roleType} · 饰 {item.role}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {item.genres.slice(0, 3).map((genre) => (
            <Tag key={genre} tone="neutral">
              {genre}
            </Tag>
          ))}
        </div>
        <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-3">
          <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
            <i className="ri-star-fill text-accent-500" aria-hidden="true" />
            {item.rating.toFixed(1)}
          </span>
          <span className="inline-flex items-center gap-1 text-xs font-label font-medium text-primary-600">
            查看详情
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </span>
        </div>
      </div>
    </Link>
  );
}